import React, { useMemo } from 'react'
import { Col, Form, Row } from 'antd'
import PropTypes from 'prop-types'

import {
  FormTextareaInput,
  IngredientsAutocheckTree,
} from '../../../common/components/sections'
import { nodePropType } from '../../../common/prop-types'
import { getFormItemLabelAboveConfiguration } from '../../../common/utils'

import { tokenizeTextByNewLine } from '../../utils'
import { validatePhrase } from '../forms/validators'

const IngredientSpecialIgnoredCombinationCaseDefinitionFormItem = ({
  disabled,
  ingredientTreeData,
}) => {
  const textareaRules = useMemo(
    () => [
      {
        required: true,
      },
      () => ({
        validator(_, value) {
          const currentPhrases = tokenizeTextByNewLine(value)

          try {
            validatePhrase(currentPhrases, [])

            return Promise.resolve()
          } catch (error) {
            return Promise.reject(error)
          }
        },
      }),
    ],
    [],
  )

  return (
    <>
      <Row>
        <FormTextareaInput
          disabled={disabled}
          name={['caseDefinition', 'tokens']}
          label="Tokens (new line separated and with {})"
          style={{ width: 500 }}
          labelAbove
          placeholder="Tokens..."
          rules={textareaRules}
        />
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name={['caseDefinition', 'ingredients_to_check']}
            label="Ingredients to Check"
            labelCol={getFormItemLabelAboveConfiguration(true)}
            rules={[{ required: true }]}
          >
            <IngredientsAutocheckTree
              disabled={disabled}
              treeData={ingredientTreeData}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}

IngredientSpecialIgnoredCombinationCaseDefinitionFormItem.propTypes = {
  disabled: PropTypes.bool,
  ingredientTreeData: PropTypes.arrayOf(nodePropType).isRequired,
}

IngredientSpecialIgnoredCombinationCaseDefinitionFormItem.defaultProps = {
  disabled: false,
}

export default IngredientSpecialIgnoredCombinationCaseDefinitionFormItem
